<template>
    <div class="prism-player" id="player-con"></div>
</template>
<script>
/* eslint-disable */
export default {
    props:{
        videoId:{
            type:String,
            default:''
        }
    },
    data(){
        return{
            videoUrl:'',
            player:''
        }
    },
    mounted(){
        this.getUrl();
    },
    methods:{
        getUrl(){
             this.$api.integralMall.getVideoPlayURL(this.videoId).then(res => {
                this.videoUrl = res.data
                this.initPlayer();
            })
        },
        initPlayer(){
            const player = new Aliplayer({
                "id": "player-con",
                "source": this.videoUrl,
                "width": "100%",
                "height": "500px",
                "autoplay": true,
                "isLive": false,
                "rePlay": false,
                "playsinline": true,
                "preload": true,
                "controlBarVisibility": "hover",
                "useH5Prism": true
                }
            );
            this.player = player;
        }
    }
}
</script>
<style lang="stylus" scoped>
.prism-player{
    height:100%;
}
</style>

